import {
  ADD_CART_ITEM,
  DECREASE_CART_QUANTITY,
  DELETE_CART_ITEM,
  INCREASE_CART_QUANTITY
} from './actionTypes';

export const addCartItem = item => {
  return {
    type: ADD_CART_ITEM,
    payload: item,
  };
};
export const deleteCartItem = itemId => {
  return {
    type: DELETE_CART_ITEM,
    payload: itemId,
  };
};
export const increaseCartQuantity = itemId => {
  return {
    type: INCREASE_CART_QUANTITY,
    payload: itemId,
  };
};
export const decreaseCartQuantity = itemId => {
  return {
    type: DECREASE_CART_QUANTITY,
    payload: itemId,
  };
};
